export enum PushAppType {
    None = 0,
    MobileSearch = 1,
    MobileVendor = 2,
    TruckDownWeb = 3,
    PlanRvWeb = 4
}